// extracted by mini-css-extract-plugin
module.exports = {"card":"batch_card__dAmnZ","anchor-level":"batch_anchor-level__y94lB","header":"batch_header__fcj1t","mentor":"batch_mentor__I1cz3","tagline":"batch_tagline__sOqwH"};